import React from 'react';
import { Navigate } from 'react-router-dom';
import { useTeamStore } from '../../store/teamStore';

interface CoachFeatureGateProps {
  children: React.ReactNode;
}

/**
 * Redirects away from coach-only routes (Roster, Lineup) for a personal
 * (parent/player) account — multi-player roster/depth-chart management has
 * nothing for a one-player account. Practices and Game Plans are NOT gated
 * here: generating a practice or game plan from one athlete's own stats is
 * one of the app's core selling points for a personal account too, just
 * with a thin roster/depth-chart behind it.
 */
export const CoachFeatureGate: React.FC<CoachFeatureGateProps> = ({ children }) => {
  const { currentTeam } = useTeamStore();
  if (currentTeam?.isPersonal) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
};

export default CoachFeatureGate;
